import { h } from 'preact';

import UniversalMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaUniversal';

export default class UniversalLocalMovieMediaEditor extends UniversalMovieMediaEditor {

	renderHeroImage() {
		return super.renderHeroImage({
			label: 'Hero still',
			focalPoint: true
		});
	}

	renderHeroImageMobile() {
		// No hero image for mobile as the focal point selector will be used instead
		return null;
	}

	getSections() {
		return [
			{ label: 'Key art', content: [this.renderOnesheet()] },
			{ label: 'Hero', note: 'Select either a video or image background for the hero section on the landing page', content: this.renderSectionHero() },
			{ label: 'YouTube trailers', note: 'Drag to reorder', content: this.renderTrailers() },
			{ label: 'Gallery', note: 'Drag to reorder', content: this.renderGallery() },
			{ label: 'Footer logos', note: 'Drag to reorder', content: this.renderFooterLogos() },
		].filter(Boolean);
	}
}